'use strict';

const $window   = $(window);
const $document = $(document);
const $body     = $('body');

let wW          = $window.outerWidth();
let wH          = $window.outerHeight();
let dH          = $document.outerHeight();

const $lazyComponents = $('[data-loading-type="lazy"]');

function showSectionById(id) {
    const $section = document.getElementById(id);
    const $link    = document.querySelector(`button[aria-controls="${id}"]`);

    if ($section) {
        const isHidden = $section.classList.contains('hide');

        if (isHidden) {
            $section.classList.remove('hide');
            $section.classList.add('show');

            $section.setAttribute('aria-hidden', 'false');

            const focusableElements = $section.querySelectorAll('a, button, input, select, textarea, [tabindex]');
            focusableElements.forEach(element => {
                element.removeAttribute('tabindex');
            });

            if ($link) {
                $link.setAttribute('aria-expanded', 'true');
            }

            $window.trigger('scroll');
        } else {
            $section.classList.remove('show');
            $section.classList.add('hide');

            $section.setAttribute('aria-hidden', 'true');

            const focusableElements = $section.querySelectorAll('a, button, input, select, textarea, [tabindex]');
            focusableElements.forEach(element => {
                element.setAttribute('tabindex', '-1');
            });

            if ($link) {
                $link.setAttribute('aria-expanded', 'false');
            }
        }
    }
}

$document.on('preloaded.after', function () {
    $window
        .on('scroll', function () {
            if (wW > 1023) {
                Animator.onScroll();
            }

            if (typeof Navigation !== 'undefined') { Navigation.onScroll(); }
        })
        .trigger('scroll');
});

$document.on('preloaded.before', function () {
    $window
        .on('resize', function () {
            wW = $window.outerWidth();
            wH = $window.outerHeight();
            dH = $document.outerHeight();
        });

    Component.init();

    if (typeof Navigation !== 'undefined') { Navigation.init(); }

    const images = document.querySelectorAll('img[data-src]');
    lazyload(images);

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && entry.target.dataset.loadingStatus === 'false') {
                const event = new Event('arrived');
                entry.target.dispatchEvent(event);
                entry.target.dataset.loadingStatus = 'true';
            }
        });
    }, {});

    $lazyComponents.toArray().forEach(component => {
        observer.observe(component);
    });

    const id = window.location.hash.substring(1);

    if (id) {
        showSectionById(id);
    } else {
        document.querySelectorAll('section.topic-search').forEach(section => {
            const focusableElements = section.querySelectorAll('a, button, input, select, textarea, [tabindex]');

            focusableElements.forEach(element => {
                element.setAttribute('tabindex', '-1');
            });
        });
    }

    $window.trigger('resize').trigger('popstate');
});

$body.waitForImages(true)
    .progress((loaded, count, success) => {
        count++;

        let percent = (loaded * 100 / count);

        TweenLite.to('.preloader__bar__progress', .4, { width: percent+'%', ease: Power2.easeInOut });
    })
    .done(() => {
        TweenLite.to('.preloader__bar__progress', .3, { width: '100%', onComplete: () => {
            $document.trigger('preloaded.before');

            TweenLite.to('.preloader', .2, { opacity: 0, display: 'none', ease: Linear.easeNone, onComplete: () => $document.trigger('preloaded.after') });
        } });
    });
